import { parse, isValid } from 'date-fns'
import { enGB } from 'date-fns/locale'

import { validateCNPJ } from './cnpj-validator'
import {
  EMAIL_REGEX,
  HAS_LOWER_CASE_CHARACTER_REGEX,
  HAS_UPPER_CASE_CHARACTER,
  DATE_REGEX,
} from './regex'

export const EMAIL_VALIDATION = (value: string) => {
  const noStartAndEndSpaces = value.trim()
  return EMAIL_REGEX.test(noStartAndEndSpaces) || 'Invalid email'
}

type PasswordRulesKeys =
  | 'hasMinimumTwelveCharacters'
  | 'hasUpperCaseCharacter'
  | 'hasLowerCaseCharacter'

export const PASSWORD_RULES_LABELS: Record<PasswordRulesKeys, string> = {
  hasMinimumTwelveCharacters: 'At least 12 characters',
  hasUpperCaseCharacter: 'At least 1 uppercase letter',
  hasLowerCaseCharacter: 'At least 1 lowercase letter',
}

export const PASSWORD_RULES_KEYS = Object.keys(PASSWORD_RULES_LABELS) as PasswordRulesKeys[]

export const PASSWORD_RULES_VALIDATION = {
  hasMinimumTwelveCharacters: (value: string) =>
    value?.length >= 12 || PASSWORD_RULES_LABELS.hasMinimumTwelveCharacters,

  hasUpperCaseCharacter: (value: string) =>
    HAS_UPPER_CASE_CHARACTER.test(value) || PASSWORD_RULES_LABELS.hasUpperCaseCharacter,

  hasLowerCaseCharacter: (value: string) => {
    return (
      (HAS_LOWER_CASE_CHARACTER_REGEX.test(value) && !!value) ||
      PASSWORD_RULES_LABELS.hasLowerCaseCharacter
    )
  },
}

const parseDate = (value: string) => {
  return parse(value, 'P', new Date(), { locale: enGB })
}

export const BIRTH_DATE_VALIDATION = {
  isValidDate: (value: string) => {
    const parsedDate = parseDate(value)
    const isValidDate = isValid(parsedDate)
    return (DATE_REGEX.test(value) && isValidDate) || 'Invalid date format. Please, use DD/MM/YYYY'
  },

  isUnderAge: (value: string) => {
    const parsedDate = parseDate(value)
    const years = Math.floor(
      Math.ceil(Math.abs(parsedDate.getTime() - new Date().getTime()) / (1000 * 3600 * 24)) / 365.25
    )
    return years >= 18 || 'You must be 18 years or older'
  },
}

export const CNPJ_VALIDATION = (value: string) => {
  return validateCNPJ(value) || 'Invalid CNPJ'
}
